import './Toaster.scss';
import React from 'react';
import PropTypes from 'prop-types';

class FailedToaster extends React.Component {
  static propTypes = {
    dismissText: PropTypes.string,
    onDismiss: PropTypes.func,
    text: PropTypes.string.isRequired,
  }

  static contextTypes = {
    getString: PropTypes.func.isRequired,
  };

  renderActionBar() {
    const { onDismiss, dismissText } = this.props;
    const { getString } = this.context;

    if (!onDismiss) {
      return null;
    }

    return (
      <div className="toaster-action">
        <a className="btn btn-link" href="/help">
          <span>{getString('AA_Contact_Us')}</span>
        </a>
        <a className="btn btn-link" onClick={onDismiss}>
          <span>{dismissText || getString('AA_OK')}</span>
        </a>
      </div>
    );
  }

  render() {
    return (
      <div className="toaster-wrapper">
        <div className="toaster-background" />
        <div className="toaster">
          <div className="toaster-content">
            <div className="toaster-icon">
              <span className="glyphicon glyphicon-remove" aria-hidden="true" />
            </div>
            <span className="toaster-text">{this.props.text}</span>
          </div>
          {this.renderActionBar()}
        </div>
      </div>
    );
  }
}

export default FailedToaster;
